// React

// Material UI
import { Radio } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { setEnding, setEndingDate } from '../../../../../../../store/customizeRepeatSlice';

const EndingOn = () => {
  const theme = createTheme({
    palette: { primary: { main: '#F17023' } },
    components: {
      MuiTextField: {
        defaultProps: { variant: 'standard' },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: { borderRadius: '10px' },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: { cursor: 'pointer', textAlign: 'center' },
        },
      },
      MuiInput: {
        defaultProps: { disableUnderline: true },
      },
      MuiFormControl: {
        styleOverrides: {
          root: {
            padding: '6px 10px',
            borderRadius: '8px',
            border: '1px solid #E8EBED',
            '&:hover': { border: '1px solid #98A6AE' },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: { '&.Mui-selected': { color: 'white' } },
        },
      },
      MuiTypography: {
        styleOverrides: {
          body1: { fontSize: '16px' },
        },
      },
      MuiPickersCalendarHeader: {
        styleOverrides: {
          root: {
            marginTop: 0,
            marginBottom: '21px',
            justifyContent: 'center',
          },
          switchViewButton: { display: 'none' },
        },
      },
      MuiPickersArrowSwitcher: {
        styleOverrides: {
          button: { padding: 0, color: '#F17023' },
        },
      },
      MuiDayCalendar: {
        styleOverrides: {
          header: {
            justifyContent: 'center',
            '& > .MuiDayCalendar-weekDayLabel:first-of-type': { color: '#FAB97A' },
          },
          weekDayLabel: { color: '#C6CED2', fontSize: '14px' },
          weekContainer: {
            justifyContent: 'center',
            '& .MuiPickersDay-root': { fontWeight: 500 },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: '#C6CED2',
            '&.Mui-checked': { color: '#F17023' },
          },
        },
      },
    },
  });

  const ending = useSelector((state) => state.customizeRepeat.ending);
  const endingDate = useSelector((state) => state.customizeRepeat.endingDate);
  const dispatch = useDispatch();

  const handleEndingChange = (e) => {
    dispatch(setEnding(e.target.value));
  };

  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: '8px',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            columnGap: '8px',
          }}
        >
          <Radio checked={ending === 'false'} onChange={handleEndingChange} value="false" />
          <span>Never</span>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            columnGap: '8px',
          }}
        >
          <Radio checked={ending === 'true'} onChange={handleEndingChange} value="true" />
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeProvider theme={theme}>
              <DatePicker
                disabled={ending === 'false'}
                value={endingDate}
                format="EEE dd MMM yyyy"
                onChange={(value) => dispatch(setEndingDate(value))}
                slotProps={{
                  textField: { style: { maxWidth: 170 } },
                  openPickerButton: { sx: { display: 'none' } },
                }}
                minDate={new Date()}
              />
            </ThemeProvider>
          </LocalizationProvider>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default EndingOn;
